module.exports = __webpack_public_path__ + "static/media/agente_icon.b26d849d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Header/agente_icon.svg
// module id = 1777
// module chunks = 0